import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Registration Search", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_box = _resolveComponent("search-box")
  const _component_registration_result = _resolveComponent("registration-result")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_search_box, {
        isLoading: _ctx.isSearchLoading,
        onRegistrationSearched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearchClick($event)))
      }, null, 8, ["isLoading"])
    ]),
    _hoisted_4,
    _createVNode(_component_registration_result, {
      registrations: _ctx.registrations,
      isLoading: _ctx.isSearchLoading,
      currentCriteria: _ctx.searchCriteria,
      onRegistrationRenewed: _ctx.searchRegistrations,
      onExcelExportClicked: _ctx.customExportFn
    }, null, 8, ["registrations", "isLoading", "currentCriteria", "onRegistrationRenewed", "onExcelExportClicked"])
  ]))
}